import { ApiTypes } from "types"
import NotificationEventTypeId from "types/enums/NotificationEventTypeId"

export const MONTHLY_ENGAGEMENT_REPORT_EVENT_TYPE = {
  id: NotificationEventTypeId.MonthlyEngagementReport,
  name: "Monthly Engagement Report",
} as const

export const hasActiveMonthlyEngagementUserEventType = (userEventTypes?: ApiTypes.Model.UserEventType[]) =>
  Boolean(
    userEventTypes?.some(
      eventType =>
        eventType.id === MONTHLY_ENGAGEMENT_REPORT_EVENT_TYPE.id &&
        eventType.name === MONTHLY_ENGAGEMENT_REPORT_EVENT_TYPE.name &&
        eventType.active,
    ),
  )
